import { WriterInfoServiceExtension } from '@blocksuite/affine/shared/services';
import { OnEvent, Service } from '@toeverything/infra';

import { type Workspace, WorkspaceInitialized } from '../../workspace';
import type { DocImpl } from '../../workspace/impls/doc';
import type { WorkspaceServerService } from './workspace-server';

/**
 * This service is used to set the writer info for the blocksuite editor.
 */
@OnEvent(WorkspaceInitialized, i => i.onWorkspaceInitialized)
export class BlocksuiteWriterInfoService extends Service {
  constructor(private readonly workspaceServerService: WorkspaceServerService) {
    super();
  }

  onWorkspaceInitialized(workspace: Workspace) {
    const setWriterInfo = (doc: DocImpl) => {
      const account = this.workspaceServerService.server?.account$.value;
      doc.awarenessStore.awareness.setLocalStateField('user', {
        name: account?.label,
      });
      doc.storeExtensions.push(
        WriterInfoServiceExtension({
          getWriterInfo: () => {
            if (!account) {
              return null;
            }
            return {
              id: account.id,
              name: account.label,
              avatar: account.avatar,
            };
          },
        })
      );
    };
    // 1. 处理当前已加载的文档
    workspace.docCollection.docs.forEach(doc => {
      setWriterInfo(doc as DocImpl);
    });

    // 2. 监听未来加载的文档 (使用 slots.docCreated)
    // workspace.docCollection 是 WorkspaceImpl 实例，具有 slots.docCreated
    const collection = workspace.docCollection as any;
    if (collection.slots?.docCreated) {
      const subscription = collection.slots.docCreated.subscribe((docId: string) => {
        const doc = workspace.docCollection.getDoc(docId) as DocImpl;
        if (doc) {
          setWriterInfo(doc);
        }
      });
      this.disposables.push(() => subscription.unsubscribe());
    }
  }
}
